<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
import api from '@/api';
export default {
  name: 'App',
  mounted() {
    if (sessionStorage.getItem("_ct_")) {
      api.setAuth(sessionStorage.getItem("_ct_"));
    } else {
      this.$router.replace("login");
    }
  }
};
</script>
